import { ar, ca, enUS, es, et, mt, pt, ru } from "date-fns/locale";
import type { Locales } from "~/i18n/i18n-types";
import { useLocale } from "./use-locale";

const useDateFnsLocale = () => {
	const locale = useLocale() as Locales;

	switch (locale) {
		case "ar":
			return ar;
		case "es":
			return es;
		case "ca":
			return ca;
		case "pt":
			return pt;
		case "ee":
			return et;
		case "ru":
			return ru;
		case "mt":
			return mt;
		case "tl":
			return enUS;
		default:
			return enUS;
	}
};

export default useDateFnsLocale;
